// extracted by mini-css-extract-plugin
export default {"fullScreenContainer":"RenderLevel_fullScreenContainer__Z0vgW","gameScreen":"RenderLevel_gameScreen__OywY2"};